<template>
  <div id="app">
    <router-view></router-view>
    <Cookie></Cookie>
    <div class="back-to-top" @click="backToTop" v-show="backToTopShow"></div>
  </div>
</template>

<script>
import Cookie from "./components/cookie";
export default {
  name: "App",
  data() {
    return {
      page_scroll_top: 0,
    };
  },
  components: {
    Cookie,
  },
  computed: {
    backToTopShow() {
      return this.page_scroll_top > 100;
    },
  },
  mounted() {
    this.pageScrollTopWatcher();
  },
  methods: {
    pageScrollTopWatcher() {
      window.addEventListener("scroll", () => {
        this.page_scroll_top =
          document.documentElement.scrollTop || document.body.scrollTop;
      });
    },
    backToTop() {
      setTimeout(() => {
        var top = document.documentElement.scrollTop;
        var speed = top / 4 > 200 ? top / 4 : 200;
        if (top > 0) {
          window.scrollTo(0, top - speed > 0 ? top - speed : 0);
          this.backToTop();
        }
      }, 20);
      // document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  margin: 0;
}
@font-face {
  font-family: "NexaBlack";
  src: url("./assets/fonts/NexaBlack.otf");
}
@font-face {
  font-family: "NexaLight";
  src: url("./assets/fonts/NexaLight.otf");
}
@font-face {
  font-family: "NexaBold";
  src: url("./assets/fonts/NexaBold.otf");
}
.bold {
  font-family: "NexaBold";
}
.light {
  font-family: "NexaLight";
}
.NexaBlack {
  font-family: "NexaBlack";
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: NexaLight;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .back-to-top {
    position: fixed;
    bottom: 100px;
    right: 40px;
    width: 50px;
    height: 50px;
    background: #fff url("./assets/images/backToTop.png") no-repeat center
      center;
    border-radius: 50%;
    box-shadow: rgba(132, 132, 132, 0.15) 0 0 6px 0;
    cursor: pointer;
    z-index: 9999;
    @media (max-width: 992px) {
      bottom: 80px;
    }
  }
  .swiper-container {
    height: 100%;
  }
}

/*全局media样式，用于小屏时切换图片*/
@media (max-width: 767px) {
  .visible-md {
    display: block;
  }
  .hidden-md {
    display: none !important;
  }
}
@media (min-width: 767px) {
  .visible-md {
    display: none !important;
  }
  .hidden-md {
    display: block;
  }
}

@font-face {
  font-family: "number";
  src: url("./assets/fonts/number.ttf");
}
</style>